export const COLOUR_DAMAGE_REQUEST = "COLOUR_DAMAGE_REQUEST";
export const COLOUR_DAMAGE_SUCCESS = "COLOUR_DAMAGE_SUCCESS";
export const COLOUR_DAMAGE_FAILED = "COLOUR_DAMAGE_FAILED";